export default function fixedbar(el, options = {}) {
  let o = {
    scrollToggle      : window.innerHeight * 0.75,
    transitionDuration: 300,
    ...options
  };

  let stateFixed = false;
  let pane       = el.querySelector('.fixed-bar__pane');

  window.addEventListener('scroll', e => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > o.scrollToggle) {
      if (!stateFixed) {
        stateFixed          = !stateFixed;
        el.style.paddingTop = pane.clientHeight + 'px';
        el.classList.add('is-fixed');
        pane.style.top = -pane.clientHeight + 'px';
        setTimeout(() => {
          pane.classList.add('in');
          setTimeout(() => pane.style.top = 0, 0);
        }, 0);
      }
    } else {
      if (stateFixed) {
        stateFixed     = !stateFixed;
        pane.style.top = -pane.clientHeight + 'px';
        setTimeout(() => {
          pane.classList.remove('in');
          el.classList.remove('is-fixed');
          pane.style.top      = '';
          el.style.paddingTop = '';
        }, o.transitionDuration);
      }
    }
  });
}



// WEBPACK FOOTER //
// ./source/js/components/fixed-bar.js